$(document).ready(function () {
    var currentLanguage = $('html').attr('lang');
    var name = "The Nobia Share"

    if (currentLanguage === 'sv') {
        name = "Nobia aktien";
    }
  
    $(".alertir-ticker").ticker({
        dataUrl: 'https://api.alertir.com/',
        apiKey: '16760a781fa6b7f1310a1aeabf926e1d1c9fc92c',
        instrument: [{
            id: 'MDA:3956',
            name: 'Nobia'
        }],
        template: function (data) {
            var pos = data.formatted.diff > 0 ? '+' : '',
                last = data.formatted.last,
                diff = data.formatted.diff,
                diffpercent = data.value.diffpercent ? data.formatted.diffpercent + '%' : '';

            if (data.value.diffpercent < 0) {
                return '<div class="header-stockDetails"><span class="header-stockDetails--price">'
                    + data.formatted.last +
                    '</span> SEK<span class="header-stockDetails--percent"> ' + pos + diffpercent +
                    '</span></div>';
            }
            else {
                return '<div class="header-stockDetails"><span class="header-stockDetails--price">'
                    + data.formatted.last +
                    '</span> SEK<span class="header-stockDetails--percent"> ' + pos + diffpercent +
                    '</span></div>';
            }
        }
    });

    //$(".c-hero__ticker").ticker({
    //    dataUrl: '//vp166.alertir.com/afw/data/',
    //    instrument: [{
    //        id: 'MDA:3956',
    //        name: name
    //    }],
    //    template: function (data) {            
    //        var pos = data.formatted.diff > 0 ? '+' : '',
    //            last = data.formatted.last,
    //            diff = data.formatted.diff !== '-' ? data.formatted.diff : '',
    //            diffpercent = data.value.diffpercent ? ' ' + data.formatted.diffpercent + '%' : '';

    //        var summary = pos + diffpercent !== '' ? '(' + pos + diffpercent + ')' : '';

    //        if (data.value.diffpercent < 0) {
    //            return '<div class="c-hero-stock c-hero-stock--negative">'
    //                + '<div class="c-hero-stock__details"><span class="c-hero-stock__price">'
    //                + data.formatted.last +
    //                '</span><span class="c-hero-stock__currency">SEK</span></div><div class="c-hero-stock__margins">'
    //                + '<span class="c-hero-stock__name">STO:NOB</span>'
    //                + '<span class="c-hero-stock__diff">'+ diff + '</span>'
    //                + '<span class="c-hero-stock__percentage">' + summary + '</span></div>';
    //        }
    //        else {
    //            return '<div class="c-hero-stock">'
    //                + '<div class="c-hero-stock__details"><span class="c-hero-stock__price">'
    //                + data.formatted.last +
    //                '</span><span class="c-hero-stock__currency">SEK</span></div><div class="c-hero-stock__margins">'
    //                + '<span class="c-hero-stock__name">STO:NOB</span>'
    //                + '<span class="c-hero-stock__diff">' + diff + '</span>'
    //                + '<span class="c-hero-stock__percentage">' + summary + '</span></div>';
    //        }
    //    }
    //});
});